export interface AppraisalItem {
  surveyId: number,
  facetId: number,
  categoryId: number,
  elementId: number,
  subelementId: number,
  surveyTitle?: string,
  facetTitle?: string,
  categoryTitle?: string,
  elementTitle?: string,
  subelementTitle: string,
}

export function extractAppraisalItem(a: any): AppraisalItem | null {
  return a.value.survey ? {
    surveyId: a.value.survey.value,
    surveyTitle: a.value.survey.title,
    facetId: a.value.survey_facets.value,
    facetTitle: a.value.survey_facets.title,
    categoryId: a.value.facet_categories.value,
    categoryTitle: a.value.facet_categories.title,
    elementId: a.value.category_elements.value,
    elementTitle: a.value.category_elements.title,
    subelementId: a.value.element_subelements.value,
    subelementTitle: a.value.element_subelements.title,
  } as AppraisalItem : null
}

export function getAppraisalTitlePath(item: AppraisalItem): string {
  return (item.subelementId ? item.surveyTitle +
    " / " + item.facetTitle +
    " / " + item.categoryTitle +
    " / " + item.elementTitle +
    " / " + item.subelementTitle :
    item.elementId ? item.surveyTitle +
      " / " + item.facetTitle +
      " / " + item.categoryTitle +
      " / " + item.elementTitle :
      item.categoryId ? item.surveyTitle +
        " / " + item.facetTitle +
        " / " + item.categoryTitle :
        item.facetId ? item.surveyTitle +
          " / " + item.facetTitle :
          item.surveyId ? item.surveyTitle : "") || ""
}

export function getAppraisalLastElementName(item: AppraisalItem): string | null {
  return item.subelementId ? "subelement" :
    item.elementId ? "element" :
      item.categoryId ? "category" :
        item.facetId ? "facet" :
          item.surveyId ? "survey" : null
}
